import { render, staticRenderFns } from "./PainelObservatorio.vue?vue&type=template&id=e4691dc8"
import script from "./PainelObservatorio.vue?vue&type=script&lang=js"
export * from "./PainelObservatorio.vue?vue&type=script&lang=js"
import style0 from "./PainelObservatorio.vue?vue&type=style&index=0&id=e4691dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports